var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useMedia } from 'react-media-match';
import cuid from 'cuid';
import styled, { ThemeProvider, withTheme, css } from 'styled-components';
import filterTimeControl from '../../utils/filterTimeControl';
import { footerWrapperTheme } from './theme';
import FooterBlockText from './BlockText';
import FooterBlockList from './BlockList';
import FooterBlockImage from './BlockImage';
import FooterAccordion from './FooterAccordion';
import FooterBlockBadges from './BlockBadges';
import ComponentItemType from '../ComponentRecognizer/SchemaTypes';
import Html from '../Html';
import ModalByTextlink from '../ModalByTextlink';
// eslint-disable-next-line no-shadow
export var BlockTypes;
(function (BlockTypes) {
    BlockTypes["BlockText"] = "footer_block_text";
    BlockTypes["BlockList"] = "footer_block_list";
    BlockTypes["BlockImage"] = "footer_block_image";
    BlockTypes["BlockBadges"] = "footer_block_badges";
})(BlockTypes || (BlockTypes = {}));
// eslint-disable-next-line no-shadow
export var TestIds;
(function (TestIds) {
    TestIds["FooterIdDesktop"] = "cms-footer-testid-desktop";
    TestIds["FooterIdMobile"] = "cms-footer-testid-mobile";
    TestIds["SocketId"] = "cms-footer-testid-socket";
})(TestIds || (TestIds = {}));
var StyledParagraphBasic = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:last-of-type {\n    padding-bottom: 0;\n  }\n"], ["\n  &:last-of-type {\n    padding-bottom: 0;\n  }\n"])));
var StyledBlockHeadline = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  font-weight: ", ";\n  margin-bottom: 0.75rem;\n"], ["\n  ",
    ";\n  font-weight: ", ";\n  margin-bottom: 0.75rem;\n"])), function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var component = _a.theme.component;
    return ((_d = (_c = (_b = component === null || component === void 0 ? void 0 : component.footer) === null || _b === void 0 ? void 0 : _b.block) === null || _c === void 0 ? void 0 : _c.headline) === null || _d === void 0 ? void 0 : _d.family) ? "font-family: " + ((_g = (_f = (_e = component === null || component === void 0 ? void 0 : component.footer) === null || _e === void 0 ? void 0 : _e.block) === null || _f === void 0 ? void 0 : _f.headline) === null || _g === void 0 ? void 0 : _g.family)
        : '';
}, function (_a) {
    var _b, _c;
    var component = _a.theme.component;
    return ((_c = (_b = component === null || component === void 0 ? void 0 : component.footer) === null || _b === void 0 ? void 0 : _b.block) === null || _c === void 0 ? void 0 : _c.headline.weight) || 'bold';
});
var StyledBlock = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: calc(", " / 4);\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: 3.75rem;\n\n  a {\n    text-decoration: none;\n  }\n"], ["\n  width: calc(", " / 4);\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: 3.75rem;\n\n  a {\n    text-decoration: none;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.maxWidth;
});
var StyledFooterMobile = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: ", ";\n  margin: ", ";\n  padding: ", ";\n  font-size: ", ";\n  color: ", ";\n  background-color: ", ";\n"], ["\n  max-width: ", ";\n  margin: ", ";\n  padding: ", ";\n  font-size: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.maxWidth;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.footerMobile.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.footerMobile.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.fontSizeMobile;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.backgroundColor;
});
var StyleFooterImages = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  .component-recognizer-container[type='footer_group_image'].layout-variant-inline {\n    width: auto;\n    display: flex;\n    align-content: center;\n    flex-shrink: 0;\n    vertical-align: top;\n  }\n\n  .footer_block_badges {\n    display: flex;\n    gap: 0.8rem;\n  }\n"], ["\n  .component-recognizer-container[type='footer_group_image'].layout-variant-inline {\n    width: auto;\n    display: flex;\n    align-content: center;\n    flex-shrink: 0;\n    vertical-align: top;\n  }\n\n  .footer_block_badges {\n    display: flex;\n    gap: 0.8rem;\n  }\n"])));
var StyledFooter = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 2.5rem;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", ";\n\n  p {\n    margin: 0;\n    padding: 0 0 0.5rem 0;\n\n    ", "\n  }\n"], ["\n  ", "\n\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 2.5rem;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", ";\n\n  p {\n    margin: 0;\n    padding: 0 0 0.5rem 0;\n\n    ", "\n  }\n"])), StyleFooterImages, function (_a) {
    var component = _a.theme.component;
    return component.footer.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.backgroundColor;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.fontSizeDesktop;
}, StyledParagraphBasic);
var StyledInnerFooter = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row wrap;\n  flex-direction: row;\n  align-items: stretch;\n  min-width: 71.5rem;\n\n  max-width: ", ";\n  margin: ", ";\n  padding: ", ";\n\n  > div {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n\n    flex-basis: calc(100% / 4);\n    margin-right: 0;\n    margin-bottom: 4.25rem;\n  }\n"], ["\n  display: flex;\n  flex-flow: row wrap;\n  flex-direction: row;\n  align-items: stretch;\n  min-width: 71.5rem;\n\n  max-width: ", ";\n  margin: ", ";\n  padding: ", ";\n\n  > div {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n\n    flex-basis: calc(100% / 4);\n    margin-right: 0;\n    margin-bottom: 4.25rem;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.maxWidth;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.padding;
});
var StyledInnerFooterMobile = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n\n  padding-bottom: 0;\n"], ["\n  ", "\n\n  padding-bottom: 0;\n"])), StyleFooterImages);
var StyledSocketBasic = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  color: ", ";\n  margin: ", ";\n\n  a {\n    color: ", ";\n    text-decoration: none;\n  }\n  p {\n    margin: 0;\n    padding: 0 0 0.5rem 0;\n    ", "\n  }\n"], ["\n  color: ", ";\n  margin: ", ";\n\n  a {\n    color: ", ";\n    text-decoration: none;\n  }\n  p {\n    margin: 0;\n    padding: 0 0 0.5rem 0;\n    ", "\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.footer.socket.color;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.socket.color;
}, StyledParagraphBasic);
var StyledInnerSocket = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  min-width: 71.5rem;\n  max-width: ", ";\n  padding: ", ";\n  font-size: ", ";\n\n  ", ";\n"], ["\n  min-width: 71.5rem;\n  max-width: ", ";\n  padding: ", ";\n  font-size: ", ";\n\n  ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.footer.footer.maxWidth;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.socket.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.socket.fontSize;
}, StyledSocketBasic);
var StyledInnerSocketMobile = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  padding: ", ";\n  font-size: ", ";\n\n  p {\n    padding-bottom: 0.75rem;\n  }\n"], ["\n  ", ";\n  padding: ", ";\n  font-size: ", ";\n\n  p {\n    padding-bottom: 0.75rem;\n  }\n"])), StyledSocketBasic, function (_a) {
    var component = _a.theme.component;
    return component.footer.socketMobile.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.footer.socketMobile.fontSize;
});
export var FooterBlockContent = function (_a) {
    var innerParagraph = _a.innerParagraph, uuid = _a.uuid;
    switch (innerParagraph.type) {
        case BlockTypes.BlockText:
            return React.createElement(FooterBlockText, { uuid: uuid, contentData: innerParagraph });
        case BlockTypes.BlockList:
            return React.createElement(FooterBlockList, { uuid: uuid, contentData: innerParagraph });
        case BlockTypes.BlockImage:
            return React.createElement(FooterBlockImage, { uuid: uuid, contentData: innerParagraph });
        case BlockTypes.BlockBadges:
            return React.createElement(FooterBlockBadges, { uuid: uuid, contentData: innerParagraph });
        default:
            return null;
    }
};
var renderSocketData = function (socketData, uuid) {
    var _a, _b;
    var elements = [];
    (_b = (_a = socketData === null || socketData === void 0 ? void 0 : socketData.filter(function (item) { return item.parent_field_name === 'field_socket'; })) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return filterTimeControl(item); })) === null || _b === void 0 ? void 0 : _b.forEach(function (item, index) {
        if (item.type === ComponentItemType.Html) {
            elements.push(React.createElement(Html, { contentData: item, key: "render-socket-html-" + cuid(), componentKey: "render-socket-html-" + index + "-" + uuid }));
        }
        if (item.type === ComponentItemType.TextlinkModal) {
            elements.push(React.createElement(ModalByTextlink, { contentData: item, key: "render-socket-modalboxbytextlink-" + uuid, componentKey: "render-socket-modalboxbytextlink-" + index + "-" + uuid }));
        }
    });
    return elements;
};
var Socket = function (_a) {
    var socketData = _a.socketData, _b = _a.uuid, uuid = _b === void 0 ? cuid() : _b;
    var isMobile = useMedia({ mobile: true, tablet: true, desktop: false });
    var el = isMobile ? (React.createElement(StyledInnerSocketMobile, { key: "socket-styled-inner-" + uuid + "-mob" }, socketData && renderSocketData(socketData))) : (React.createElement(StyledInnerSocket, { key: "socket-styled-inner-" + uuid }, socketData && renderSocketData(socketData)));
    return el;
};
var Footer = function (_a) {
    var _b, _c;
    var footerData = _a.footerData, _d = _a.onlySocket, onlySocket = _d === void 0 ? false : _d, _e = _a.uuid, uuid = _e === void 0 ? cuid() : _e;
    var isMobile = useMedia({ mobile: true, tablet: true, desktop: false });
    var elements = [];
    (_c = (_b = footerData === null || footerData === void 0 ? void 0 : footerData.filter(function (item) { return item.parent_field_name === 'field_footer'; })) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return filterTimeControl(item); })) === null || _c === void 0 ? void 0 : _c.forEach(function (item) {
        var headline = item.field_headline;
        elements.push(React.createElement(StyledBlock, { key: cuid() },
            headline && (React.createElement(StyledBlockHeadline, { key: "block-headline-accordion-" + cuid() }, headline)),
            React.createElement(FooterBlockContent, { key: "footer-block-content-" + cuid(), innerParagraph: item, uuid: uuid })));
    });
    return (React.createElement(ThemeProvider, { theme: footerWrapperTheme }, !isMobile ? (React.createElement(StyledFooter, { "data-testid": TestIds.FooterIdDesktop, key: "footer-desktop" },
        !onlySocket && React.createElement(StyledInnerFooter, { key: "footer-inner" }, elements),
        React.createElement(Socket, { key: "socket-" + uuid, socketData: footerData }))) : (React.createElement(StyledFooterMobile, { "data-testid": TestIds.FooterIdMobile, key: "footer-mobile" },
        !onlySocket && (React.createElement(StyledInnerFooterMobile, { key: "footer-inner" },
            React.createElement(FooterAccordion, { key: "footer-accordion-" + uuid, contentData: footerData || [], styleType: "type1" }))),
        React.createElement(Socket, { key: "socket-" + uuid, socketData: footerData })))));
};
export default withTheme(Footer);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=index.js.map